import { api, auth } from '@/f1/service';
import _ from 'lodash'
import priceModal from '../Price.i18n'
import historyModal from '../History.i18n'
// import historyModal from '../History'
// import EventBus from '../EventBus';
// import Vue from 'vue';
const _i18n_data = {
  username: {
    EN : () => `Username required.`,
    KO : () => `아이디를 입력하세요.`,
  },
  password: {
    EN : () => `Password required.`,
    KO : () => `비밀번호를 입력하세요.`,
  }
};
const default_opt = () => ({
  perPage: 12,
  currentPage: 1,
  totalRows: 0,
  offset : 0,
  limit : 10,
  adv : false,
  sk : '', 'sv' : '', 'skt' : '', 'opt' : { },
  body : {
    and : [ { name : 'is_del', value : false, op : '=' } ],
    sort : [ { name : 'group_id' }, { name : 'id', op : 'desc' } ]
  }
})
const i18n_fields = {
  EN: [
    { key: 'apply_at', label: 'Date', sortable: false, thStyle: 'width: 5%' },
    { key: 'servicename', label: 'Service', sortable: false },
    { key: 'price', label: 'Price(A)', sortable: false  },
    { key: 'usage', label: 'Usage(B)', sortable: false  },
    { key: 'base_price', label: 'Amount(A*B)', sortable: false  },
    { key: 'discount_price', label: 'Discount(C)', sortable: false  },
    { key: 'total_price', label: 'Charge(A*B - C)', sortable: false  },
    { key: 'is_paid', label: 'Status', sortable: false  },
    { key: 'description', label: 'Info', sortable: false },
  ],
  KO: [
    { key: 'apply_at', label: '날짜', sortable: false, thStyle: 'width: 5%' },
    { key: 'servicename', label: '서비스', sortable: false },
    { key: 'price', label: '가격(A)', sortable: false  },
    { key: 'usage', label: '사용량(B)', sortable: false  },
    { key: 'base_price', label: '기본가격(A*B)', sortable: false  },
    { key: 'discount_price', label: '할인율(C)', sortable: false  },
    { key: 'total_price', label: '가격(A*B - C)', sortable: false  },
    { key: 'is_paid', label: '상태', sortable: false  },
    { key: 'description', label: '정보', sortable: false },
  ]
}


export default {
  components: { priceModal, historyModal },
  data : () => ({
    confirm_payment_history : false,
    payment_history : '',

    history : [],

    model : { credit : 0 },
    invoices : undefined,
    last_invoice: undefined,
    current : undefined,
    modal_price : false,
    auth,
    so : default_opt(),
    current_service : undefined,
    hide_canceled : true,
  }),
  computed: {
    i18n_data() { return _i18n_data; } ,
    pay() { return i18n_fields[this.i18n]; },

  },
  methods: {
    refresh() {
      this.$refs._list && this.$refs._list.refresh()
    },
    modal_history(history) {
      if(!history) { return this.$toastr.e("no have more information") }
      console.log(history.length)
      this.history = []
      history.forEach(r => {
        try {
          this.history.push(JSON.parse(r))
        } catch (e) {
          console.error(e)
          this.history.push(r)
        }
      });
      // this.$history_modal.show()
      console.log("payment history load", history.length)
    },
    getRowCount () { return this.so.totalRows || 0 },
    async Summary(){
      let rs = await api.board.Billing({ target: 'group', cmd: 'summary', user : { group_id : auth.profile.group_id }, body : { hide_cancel : this.hide_canceled } })
      if(rs.error) { return this.$toast.e("load", 'failed') }

      this.model = Object.assign({}, this.model, rs.body)
      this.invoices = this.model.invoices;
      this.last_invoice = _.max(_.map(this.invoices || [], r => { return r.is_paid == true ? r : '' }), r => r.id)
      this.so.totalRows = this.invoices.length;
      this.current = _.max(this.model.current, r => r.id);

      if(this.model.services) { this.current_service = _.filter(this.model.services, r => r.service_name == this.current.servicename) }
      this.current_service = this.current_service ? _.head(this.current_service) : {}
      // EventBus.$emit('services1', this.model.services);
      // this.current_service.customer_price = 100 // for debug

      return this.invoices
    },
    async load() { return this.Summary() },
  },
  watch: { '$route' (to, from) { console.debug(from) } },
  created() { console.log('[Console] Billing System', 'created'); },
  destroyed() { console.log('[Console] Billing System', 'destroyed'); },
  mounted() { console.log('[Console] Billing System', 'mounted'); this.load();},
}
